module.exports = __webpack_public_path__ + "img/mg-hiw.0bc976c7.png";